import { SVGProps } from '../types';
import { FileGenericIcon } from './FileGeneric';
import { FilePdfIcon } from './FilePdf';
import { FileXlsxIcon } from './FileXlsx';

const ICON_BY_EXTENSION: Record<string, (props: SVGProps) => JSX.Element> = {
  pdf: FilePdfIcon,
  xlsx: FileXlsxIcon,
  xls: FileXlsxIcon,
  xlsm: FileXlsxIcon,
  csv: FileXlsxIcon,
};

const extractExtension = (filename: string | undefined | null): string | null => {
  if (!filename) return null;
  const lastDot = filename.lastIndexOf('.');
  if (lastDot < 0 || lastDot === filename.length - 1) return null;
  return filename.slice(lastDot + 1).toLowerCase();
};

interface FileTypeIconProps extends SVGProps {
  // Filename (preferred) or bare extension. Unknown extensions render the
  // generic file icon.
  filename?: string | null;
  extension?: string | null;
}

export const FileTypeIcon = ({ filename, extension, ...rest }: FileTypeIconProps) => {
  const ext = (extension ?? extractExtension(filename))?.toLowerCase() ?? '';
  const Component = ICON_BY_EXTENSION[ext] ?? FileGenericIcon;
  return <Component {...rest} />;
};
